<ng-container *ngIf="visible">
  <div
    class="ccd-overlay"
    [@overlayAnimation]
    (click)="onOverlayClick($event)"
    (keydown)="$event.preventDefault()"
  >
    <div class="ccd-dialog" [@dialogAnimation]>
      <!-- Close Button -->
      <button
        class="ccd-dialog__close"
        (click)="close()"
        aria-label="Close dialog"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <!-- Header Icon -->
      <div class="ccd-dialog__icon-wrapper">
        <div class="ccd-dialog__icon-ring">
          <div class="ccd-dialog__icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <path
                d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <!-- Title & Subtitle -->
      <h2 class="ccd-dialog__title">Template categories Changed</h2>
      <p class="ccd-dialog__subtitle">{{ dialogSubtitle }}</p>

      <!-- Copy Button Row -->
      <div class="ccd-dialog__toolbar">
        <span class="ccd-dialog__count"
          >{{ categoryChanges.length }} template{{
            categoryChanges.length > 1 ? "s" : ""
          }}</span
        >
        <button
          class="ccd-copy-btn"
          [class.ccd-copy-btn--copied]="copied"
          (click)="copyToClipboard()"
          [attr.aria-label]="copied ? 'Copied' : 'Copy all changes'"
        >
          <ng-container *ngIf="copied; else copyAll">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path
                d="M20 6L9 17l-5-5"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Copied!</span>
          </ng-container>
          <ng-template #copyAll>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <rect
                x="9"
                y="9"
                width="13"
                height="13"
                rx="2"
                stroke="currentColor"
                stroke-width="2"
              />
              <path
                d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            <span>Copy All</span>
          </ng-template>
        </button>
      </div>

      <!-- Category Changes List -->
      <div
        class="ccd-changes"
        [class.ccd-changes--scrollable]="categoryChanges.length > 3"
      >
        <ng-container *ngFor="let change of categoryChanges; let i = index">
          <div
            class="ccd-change-card"
            [@itemAnimation]="{
              value: ':enter',
              params: { delay: getItemDelay(i) },
            }"
          >
            <!-- Template Code Badge -->
            <div class="ccd-change-card__header">
              <span class="ccd-change-card__code">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ change.templateCode }}
              </span>
              <ng-container *ngIf="change.templateName">
                <span class="ccd-change-card__name">{{
                  change.templateName
                }}</span>
              </ng-container>
            </div>

            <!-- Category Flow -->
            <div class="ccd-change-card__flow">
              <!-- Previous Category -->
              <div class="ccd-category ccd-category--previous">
                <span class="ccd-category__label">Previous</span>
                <span class="ccd-category__value">{{
                  change.previousCategory
                }}</span>
              </div>

              <!-- Arrow -->
              <div class="ccd-flow-arrow">
                <div class="ccd-flow-arrow__line"></div>
                <svg
                  class="ccd-flow-arrow__icon"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M5 12h14M13 6l6 6-6 6"
                    stroke="currentColor"
                    stroke-width="2.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <!-- New Category -->
              <div class="ccd-category ccd-category--new">
                <span class="ccd-category__label">Updated</span>
                <span class="ccd-category__value">{{ change.category }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Info Note -->
      <div class="ccd-dialog__note">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
            fill="currentColor"
          />
        </svg>
        <span>
          Category changes are determined by the META and may affect message
          pricing.
        </span>
      </div>

      <!-- Action Button -->
      <div class="ccd-dialog__actions">
        <button class="ccd-dialog__btn" (click)="close()" tabindex="0">
          Got it
        </button>
      </div>
    </div>
  </div>
</ng-container>
